import { useNavigate } from "react-router-dom";
import DOMPurify from 'dompurify';
import { getBundleLabel } from "../utils/getBundleLabel";
import { htmlHasText } from "../utils/htmlHasText";
import { useContentLinkClick } from "./ExternalLink";
import { setBacklink } from "../redux/backlinkSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

const BookForm = ({ activityId, priceArray, priceNote, isPremium, isRequestDone, isExternalPaid, isPlatformOwned }) => {
    const { t } = useTranslation();
    const handleContentLinkClick = useContentLinkClick();

    // Indirizzo l'utente alla pagina d'acquisto (verranno verificatii suoi dati col middleware UserPurchaseDataCheck)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const goToSendRequest = () => {
        dispatch(setBacklink(`/activity-details?id=${activityId}`))
        navigate(`/send-request/${activityId}`)
    }

    return (
        <div className={`w-full xl:w-[300px] min-h-[200px] h-fit border rounded-xl shadow-xl p-4 flex flex-col items-center gap-8 bg-neutral-100`}>
            {/* Badge esperienza esclusiva TicinoWild */}
            {isPlatformOwned &&
                <div className="w-full flex flex-col items-center gap-1 text-center">
                    <div className="text-[#225424] flex items-center justify-center gap-2">
                        <i className="fi fi-sr-star pt-1"></i>
                        <span>{t('ActivityCard.exclusiveTicinoWild')}</span>
                    </div>
                    <p className="text-xs text-neutral-500 italic">{t('ActivityDetails.BookForm.exclusiveDescription')}</p>
                </div>
            }
            {/* Price: un bordo per ogni singolo pacchetto (non più attorno all'intero blocco);
                la descrizione della prenotazione (priceNote, HTML Quill) sta sotto, FUORI dai
                bordi e senza titolo — compare così com'è formattata dall'admin. */}
            {!isExternalPaid && priceArray.length > 0 && <div className='flex flex-col gap-2 w-full'>
                <h3 className="text-center font-semibold text-lg">{t('ActivityDetails.BookForm.availableOptions')}</h3>
                {
                    priceArray.map((element, index) => {
                        const { label, detail } = getBundleLabel(element, t);
                        return (
                            // Opzione sold out: grigia (la dicitura arriva dal server in coda alla nota)
                            <div key={index} className={`border p-2 rounded-xl w-full text-center ${element.isSoldOut ? 'border-neutral-300 bg-neutral-200' : 'border-[#225424]'}`}>
                                <h4 className={element.isSoldOut ? 'text-neutral-400' : ''}>{label}</h4>
                                {detail && <div className="text-xs text-neutral-500">{detail}</div>}
                                {element.note && <div className="text-xs text-neutral-500">{element.note}</div>}
                            </div>
                        )
                    })
                }
                {
                    htmlHasText(priceNote) &&
                    <div
                        className='w-full mt-2'
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(priceNote) }}
                        onClick={handleContentLinkClick}
                    ></div>
                }
            </div>}

            {/* BUTTON PRENOTA */}
            {
                !isExternalPaid &&
                isPremium &&
                !isRequestDone &&
                <button className="w-full bg-[#225424] flex gap-2 items-center justify-center py-3 px-4 text-white rounded-xl" onClick={goToSendRequest}>
                    <div className='pt-0.5'><i className="fi fi-rr-calendar-check"></i></div>
                    <div>{t('ActivityDetails.BookForm.book')}</div>
                </button>
            }
            {
                !isExternalPaid &&
                isPremium &&
                isRequestDone &&
                <div className="w-full p-4 border-2 border-[#225424] bg-green-100 rounded-xl">
                    {t('ActivityDetails.BookForm.requestAlreadySent')}
                </div>
            }

            {
                !isExternalPaid &&
                !isPremium &&
                <div className="text-center font-bold text-[#225424]">{t('ActivityDetails.BookForm.freeActivity')}</div>
            }
            {
                isExternalPaid &&
                <div className="flex flex-col gap-2 text-center">
                    <div className="font-bold text-[#225424]">{t('ActivityDetails.BookForm.isExternalPaid1')}</div>
                    <div className="italic font-extralight">{t('ActivityDetails.BookForm.isExternalPaid2')}</div>
                </div>
            }
        </div>
    )
}

export default BookForm;